import { render, staticRenderFns } from "./AiPlaner.vue?vue&type=template&id=5bf5c0b2&scoped=true&"
import script from "./AiPlaner.vue?vue&type=script&lang=js&"
export * from "./AiPlaner.vue?vue&type=script&lang=js&"
import style0 from "./AiPlaner.vue?vue&type=style&index=0&id=5bf5c0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5c0b2",
  null
  
)

export default component.exports